<template>
  <!--
    DailyStat.vue
    Reusable stat card for displaying a daily metric with icon, color, and count.
    Used on the dashboard/home page.
  -->
  <v-card :loading="isLoading" class="mb-2" elevation="1" outlined>
    <v-list-item three-line>
      <!-- Icon avatar -->
      <v-list-item-avatar rounded size="60" :color="color">
        <v-icon dark>{{ icon }}</v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <!-- Stat title -->
        <div class="text-overline">{{ title }}</div>
        <!-- Stat count -->
        <v-list-item-title class="text-h6 mb-1">{{ count }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>

<script>
export default {
  name: 'DailyStat',
  props: {
    /**
     * Loading state for the card
     */
    isLoading: {
      type: Boolean,
      required: true,
    },
    /**
     * Title of the stat
     */
    title: {
      type: String,
      required: true,
    },
    /**
     * Count value to display
     */
    count: {
      type: Number,
      default: 0,
    },
    /**
     * Icon name for the avatar
     */
    icon: {
      type: String,
      required: true,
    },
    /**
     * Color for the avatar background
     */
    color: {
      type: String,
      required: true,
    },
  },
};
</script>
